var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmojiThumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.08191 27.7333H4.65457C3.7091 27.7333 3 27.0242 3 26.0787V13.5515C3 12.6061 3.7091 11.897 4.65457 11.897H8.08191C9.02738 11.897 9.73648 12.6061 9.73648 13.5515V26.0787C9.73648 27.0242 9.02738 27.7333 8.08191 27.7333Z",
    fill: "url(#paint0_linear_7560_50445)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9009 12.8971H27.8193C27.8193 12.8971 29.0011 12.8971 29.0011 15.1425C29.0011 17.388 27.8193 17.388 27.8193 17.388C27.8193 17.388 29.0011 17.388 29.0011 19.6334C29.0011 21.8788 27.8193 21.8788 27.8193 21.8788C27.8193 21.8788 29.0011 24.1243 26.6374 25.3061C26.6374 25.3061 27.8193 28.7334 24.3919 28.7334H16.5918C15.0554 28.7334 13.6372 28.1424 12.4554 27.0788C11.3917 26.0152 10.8008 24.4788 10.8008 22.9425V18.3334C10.8008 17.0334 11.2735 15.8516 12.219 14.9062C13.9917 13.0153 16.5918 9.588 14.2281 7.10619C14.2281 7.10619 14.5827 2.0244 18.7191 4.86075C22.2646 7.22437 19.9009 12.8971 19.9009 12.8971Z",
    fill: "url(#paint1_linear_7560_50445)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7560_50445",
    x1: 6.3621,
    y1: 11.8157,
    x2: 6.3621,
    y2: 27.6664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CDD83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#52C564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41AC4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7560_50445",
    x1: 19.9494,
    y1: 4.00547,
    x2: 19.9494,
    y2: 28.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDCB56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A337"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiThumb);
export default __webpack_public_path__ + "static/media/emoji_thumb.d67f135b.svg";
export { ForwardRef as ReactComponent };